import { Buffer } from 'buffer';
import CryptoJS from 'crypto-js';

const keyED = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_KEY_CODE + '');
const ivED = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_IV_CODE + '');

interface IEnDeAES {
  // mã hoá AES 256 CBC
  aesEncrypt: (data: string) => string;
  // giải mã AES 256 CBC
  aesDecrypt: (data: string) => string | undefined;
  // mã hoá Base 64
  encodeBase64: (data: string) => string;
  // giải mã Base 64
  decodeBase64: (data: string) => string | undefined;
}

const EnDeAES: IEnDeAES = {
  // mã hoá AES 256 CBC
  // mã hoá Base 64
  // giải mã AES 256 CBC
  // giải mã Base 64

  aesEncrypt: (data: string) => {
    const cipher = CryptoJS.AES.encrypt(data, keyED, {
      iv: ivED,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });
    return cipher.toString();
  },

  aesDecrypt: (data: string) => {
    try {
      const cipher = CryptoJS.AES.decrypt(data, keyED, {
        iv: ivED,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      }).toString(CryptoJS.enc.Utf8);

      // kiểm tra nếu không giải mã được (lỗi xoá char url)
      if (cipher.length !== 0) {
        return cipher;
      }
      return '';
      // window.location.href = '/'; k để tự out tránh lỗi reload liên tục khi cố tình hoặc vô ý gây lỗi
    } catch (error) {
      console.log('error', error);
      return '';
      // window.location.href = '/';
    }
  },
  encodeBase64: (data: any) => {
    return Buffer.from(data).toString('base64');
  },
  decodeBase64: (data: any) => {
    try {
      return Buffer.from(data, 'base64').toString('ascii');
    } catch (error) {
      return '';
      // window.location.href = '/';
    }
  }
};

export default EnDeAES;
